export const calculateMillisecondsBetweenCandles = ({
  timeUnit,
  candleDuration,
}) => {
  switch (timeUnit) {
    case 'MINUTES':
      return 60000 * candleDuration;
    case 'DAYS':
      return 86400000 * candleDuration;
    case 'WEEKS':
      return 200000000;
    case 'MONTHS':
      return 200000000;
    case 'QUARTERS':
      return 200000000;
    case 'YEARS':
      return 200000000;
    default:
      return 6000 * candleDuration;
  }
};
